import React from 'react';

const NoInventory = () => {
    return  <div className="noInventory">
        <p className="centeredText">No Inventory to display yet.</p>
        <img src="/images/NAA-logo.jpg" className="centered" width="200" alt="New American Arms" />
        <p className="centeredText">Please check back soon for updates!</p>
    </div>
}

export default NoInventory;